<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M14.6431 7.17812L11.8306 9.605L12.6875 13.2344C12.7348 13.4314 12.7226 13.638 12.6525 13.8281C12.5824 14.0182 12.4576 14.1833 12.2937 14.3025C12.1298 14.4217 11.9343 14.4896 11.7319 14.4977C11.5294 14.5058 11.3291 14.4538 11.1562 14.3481L7.99999 12.4056L4.84187 14.3481C4.66901 14.4532 4.46893 14.5047 4.26683 14.4963C4.06473 14.4879 3.86963 14.4199 3.70612 14.3008C3.5426 14.1817 3.41798 14.0169 3.34793 13.8271C3.27789 13.6374 3.26556 13.4311 3.31249 13.2344L4.17249 9.605L1.35999 7.17812C1.20705 7.04594 1.09644 6.87163 1.04198 6.67697C0.987517 6.4823 0.99161 6.2759 1.05375 6.08354C1.11589 5.89119 1.23332 5.7214 1.39138 5.59539C1.54944 5.46938 1.74113 5.39272 1.94249 5.375L5.62999 5.0775L7.05249 1.635C7.12949 1.44739 7.26054 1.2869 7.42897 1.17396C7.59741 1.06102 7.79563 1.00071 7.99843 1.00071C8.20123 1.00071 8.39945 1.06102 8.56788 1.17396C8.73632 1.2869 8.86737 1.44739 8.94437 1.635L10.3662 5.0775L14.0537 5.375C14.2555 5.39206 14.4477 5.46829 14.6064 5.59413C14.765 5.71997 14.883 5.88982 14.9455 6.08241C15.008 6.275 15.0123 6.48176 14.9579 6.67678C14.9034 6.8718 14.7926 7.04642 14.6394 7.17875L14.6431 7.17812Z"
      fill="currentColor"
    />
  </svg>
</template>
